// Original descriptions written for Tirupati Enterprises' Innovative Protective Packaging range.
const innovativePackagingData = {
  'paper-cushioning': {
    title: 'Paper Cushioning',
    subtitle: 'Lightweight, recyclable cushioning that protects products in transit while cutting down on plastic use.',
    intro:
      'Our paper cushioning systems convert simple kraft paper into void-fill, wrapping, and cushioning material on demand. They are easy to use at the packing station, generate minimal waste, and are fully recyclable — a practical alternative wherever plastic-based cushioning needs to be reduced.',
    image: '/images/innovativepackaging/papercushion.webp',
    products: [
      {
        slug: 'paperplus',
        name: 'PAPERplus',
        subtitle: 'Crumpled paper cushioning for void-fill and wrapping',
        image: '/images/innovativepackaging/paperplus.webp',
        bullets: [
          'Available in a standard kraft version and a fully recycled-paper option',
          'Made from renewable, recyclable paper stock',
          'Converts flat paper into cushioning pads directly at the packing bench',
          'Suitable for void-fill, wrapping, and light cushioning of packed goods',
          'Works with compact, semi-automatic paper conversion systems'
        ]
      },
      {
        slug: 'paperbubble',
        name: 'PAPERbubble',
        subtitle: 'Textured paper wrap for surface protection',
        image: '/images/innovativepackaging/paperbubble.webp',
        bullets: [
          'Embossed paper structure that cushions against knocks and scuffs',
          'Plastic-free alternative to bubble wrap for surface protection',
          'Fully recyclable with standard paper waste streams',
          'Well suited to wrapping items with delicate or finished surfaces'
        ]
      },
      {
        slug: 'paperwrap',
        name: 'PAPERwrap',
        subtitle: 'Roll-fed paper wrapping for general protection',
        image: '/images/innovativepackaging/paperwrap.webp',
        bullets: [
          'Supplied as roll stock for fast, continuous wrapping',
          'Provides an outer protective layer for boxed or irregularly shaped items',
          'Reduces reliance on plastic film for general-purpose wrapping',
          'Compatible with manual and semi-automatic dispensing setups'
        ]
      }
    ]
  },
  'air-cushioning': {
    title: 'Air Cushioning',
    subtitle: 'On-demand air pillows and film-based cushioning that fill void space while minimizing material use.',
    intro:
      'Air cushioning systems inflate film on site, turning a compact roll of material into lightweight cushions, pillows, or wrap. Because the film is inflated only when needed, storage space and material costs stay low while shipments still get reliable, shock-absorbing protection.',
    image: '/images/innovativepackaging/air/aircushion.webp',
    products: [
      {
        slug: 'airplus',
        name: 'AIRplus',
        subtitle: 'Inflatable air pillows for void-fill',
        image: '/images/innovativepackaging/air/airplus.webp',
        bullets: [
          'Air pillows inflated on demand from compact film rolls',
          'Fills empty space in cartons to stop products shifting in transit',
          'Significantly reduces packaging volume in storage compared to pre-filled cushioning',
          'Lightweight, which helps keep shipping costs down'
        ]
      },
      {
        slug: 'airmove',
        name: 'AIRmove',
        subtitle: 'Heavy-duty air cushioning for larger or heavier items',
        image: '/images/innovativepackaging/air/airmove.webp',
        bullets: [
          'Larger air cushions designed for bulkier or heavier products',
          'Reinforced film construction for added puncture resistance',
          'Absorbs impact during handling and long-distance transport',
          'Ideal for palletized loads and larger e-commerce shipments'
        ]
      }
    ]
  },
  'foam-packaging': {
    title: 'Foam Packaging',
    subtitle: 'On-demand foam solutions that mould around a product for high-performance shock and vibration protection.',
    intro:
      'Foam packaging is used where products need close-fitting, high-density protection — for fragile, heavy, or irregularly shaped items that other cushioning methods cannot fully secure. Foam is generated at the point of packing, so it forms directly around the product for a custom fit.',
    image: '/images/innovativepackaging/foam/foampacker.webp',
    products: [
      {
        slug: 'foamplus',
        name: 'FOAMplus',
        subtitle: 'On-demand foam cushioning and encapsulation',
        image: '/images/innovativepackaging/foam/foampluspacking.webp',
        bullets: [
          'Two-component foam that expands and cures directly around the packed product',
          'Provides a custom-fit cushion for fragile or irregularly shaped items',
          'Delivers high shock and vibration absorption for sensitive goods',
          'Reduces the need for multiple pre-cut foam inserts'
        ]
      },
      {
        slug: 'foam-in-place',
        name: 'Foam-in-Place Packaging',
        subtitle: 'Custom-moulded foam protection for irregular items',
        image: '/images/innovativepackaging/foam/foamplushandpacker.webp',
        bullets: [
          'Foam is dispensed and expands to fit the exact contours of the product',
          'Suited to heavy, delicate, or oddly shaped items that are hard to cushion otherwise',
          'Minimizes movement inside the shipping carton',
          'Reduces material waste compared to stocking multiple standard foam shapes'
        ]
      }
    ]
  }
};

export default innovativePackagingData;
